import React from "react";
import { Link } from "../../../design/link";
import { Text } from "../../../design/text";
import { Heading, Subheading } from "../../../design/heading";
import { DocumentIcon, UserIcon } from "@heroicons/react/20/solid";
import { Card } from "../../../design/card";
import { useUser } from "../../../contexts/UserContext";

interface SettingCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  route: string;
}

const SettingCard: React.FC<SettingCardProps> = ({
  title,
  description,
  icon,
  route,
}) => (
  <Link href={route}>
    <Card className="flex items-center p-4">
      <div className="ml-4">
        <Subheading>{title}</Subheading>
        <Text>{description}</Text>
      </div>
    </Card>
  </Link>
);

const SettingsHome: React.FC = () => {
  const { currentUser } = useUser();
  return (
    <div className="my-4">
      <Heading className="mb-8">Settings</Heading>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <SettingCard
          title="Personal Profile"
          description="Personal details, password, communication preferences, and your active sessions."
          icon={<UserIcon className="w-6 h-6" />}
          route="/settings/user"
        />
        {currentUser?.professional && (
          <SettingCard
            title="Professional Profile"
            description="Firm details, contact information, and firm description."
            icon={<DocumentIcon className="w-6 h-6" />}
            route={`/professional/${currentUser.professional}`}
          />
        )}

        <SettingCard
          title="Integrations"
          description="Integrate with third-party services and applications."
          icon={<DocumentIcon className="w-6 h-6" />}
          route="/settings/integrations"
        />
      </div>
    </div>
  );
};

export default SettingsHome;
